export default {
    sans: '"Red Hat Display", sans-serif',
};
